import './Profile.css'
import { useState} from "react";

const Profile  = ({details, school_logo}) => {

    const [toggle, setToggle] =  useState(false)


    const toggleRead = (e) => {
        const bio = e.target.previousElementSibling.previousElementSibling;
        const btnText = e.target

        if (!toggle) {
           bio.style.height = 'auto'
           setToggle(true)
           btnText.textContent = 'Read Less'

        }
       else {
           bio.style.height = '200px';
           bio.style.overflow = 'hidden';
           setToggle(false)
           btnText.textContent = 'Read More'
           window.scrollTo({top: bio.getBoundingClientRect().top + window.pageYOffset - 300})
        }
    }
    return (
        <div className = 'profile-container' >
            <div className= 'profile-details' id = {details.name.split(" ")[1].toLowerCase()}>
                <div className= 'profile-img'>
                    <img src = {details.img} alt = "profile-pic"/>
                </div>
                {school_logo !== undefined && <div className= 'school-logo'>
                    <img src = {school_logo} alt = "logo" />
                </div>}
            </div>
            <div className= 'profile-description'>
                <p className= 'name-title'> {details.name} <span> {details.title} </span> </p>
                <div className= 'bio'> {details.bio} </div>
                <hr/>
                {details.bio.length > 300 && <div className= 'read-more-toggle' onClick= {toggleRead}> Read More </div>}
            </div>
        </div>
    )
}
export default Profile;